import React from 'react';
import { motion } from 'framer-motion';
import CTAButton from './CTAButton';
import { CheckIcon, GiftIcon } from 'lucide-react';
const PricingSection: React.FC = () => {
  return <section id="pricing" className="w-full bg-background py-16" data-id="element-135">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-lg text-center" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-secondary mb-6" data-id="element-138">
            Precio especial lanzamiento
          </h2>
          <div className="mb-8" data-id="element-139">
            <p className="text-lg line-through text-gray-500" data-id="element-140">No son 97€.</p>
            <p className="text-lg line-through text-gray-500" data-id="element-141">Ni 59€.</p>
            <p className="text-lg line-through text-gray-500 mb-4" data-id="element-142">Ni 39€.</p>
            <p className="text-xl" data-id="element-143">Hoy puedes empezar por solo:</p>
            <div className="flex justify-center items-center mt-4" data-id="element-144">
              <motion.div initial={{
              scale: 1
            }} whileInView={{
              scale: [1, 1.1, 1]
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              repeatDelay: 3
            }} className="bg-primary text-white text-4xl font-bold py-4 px-8 rounded-xl" data-id="element-145">
                29 €
              </motion.div>
            </div>
          </div>

          <div className="my-12 py-8 border-t border-b border-gray-200" data-id="element-146">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="flex items-center justify-center gap-3 mb-8" data-id="element-147">
              <GiftIcon className="text-primary" size={28} data-id="element-148" />
              <h3 className="text-2xl font-serif font-bold text-secondary" data-id="element-149">
                + BONUS EXCLUSIVOS
              </h3>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-150">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} className="bg-secondary/5 p-6 rounded-xl" data-id="element-151">
                <div className="bg-primary text-white w-8 h-8 rounded-full flex items-center justify-center font-bold mb-4" data-id="element-152">
                  1️⃣
                </div>
                <h4 className="text-xl font-medium text-secondary mb-2" data-id="element-153">
                  Guía "Navidades Sin Azúcar"
                </h4>
                <p data-id="element-154">Para que no retrocedas aunque haya turrones y postres.</p>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="bg-secondary/5 p-6 rounded-xl" data-id="element-155">
                <div className="bg-primary text-white w-8 h-8 rounded-full flex items-center justify-center font-bold mb-4" data-id="element-156">
                  2️⃣
                </div>
                <h4 className="text-xl font-medium text-secondary mb-2" data-id="element-157">
                  Guía Disruptores Endocrinos
                </h4>
                <p data-id="element-158">Cambios simples en tu día a día que ayudan a:</p>
                <div className="mt-2 space-y-1" data-id="element-159">
                  <p data-id="element-160">
                    <span className="text-accent" data-id="element-161">✨</span> Desinflamar.
                  </p>
                  <p data-id="element-162">
                    <span className="text-accent" data-id="element-163">✨</span> Mejorar energía.
                  </p>
                  <p data-id="element-164">
                    <span className="text-accent" data-id="element-165">✨</span> Cuidar tus hormonas.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>

          <p className="text-lg mb-8" data-id="element-166">
            Un pequeño paso hoy. Un gran cambio en tu vida.
          </p>
          <CTAButton className="text-xl py-4 px-10" data-id="element-167">
            QUIERO MI RESET — SOLO 29 €
          </CTAButton>
          <div className="mt-16" data-id="element-168">
            <h3 className="text-2xl font-serif font-bold text-secondary mb-6" data-id="element-169">
              ¿Por qué 21 días?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-170">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} className="flex items-start gap-3" data-id="element-171">
                <div className="bg-primary rounded-full p-1 flex-shrink-0 mt-1" data-id="element-172">
                  <CheckIcon size={16} className="text-white" data-id="element-173" />
                </div>
                <p className="text-left" data-id="element-174">💥 Resetear tu paladar.</p>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="flex items-start gap-3" data-id="element-175">
                <div className="bg-primary rounded-full p-1 flex-shrink-0 mt-1" data-id="element-176">
                  <CheckIcon size={16} className="text-white" data-id="element-177" />
                </div>
                <p className="text-left" data-id="element-178">💥 Reiniciar tu energía.</p>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="flex items-start gap-3" data-id="element-179">
                <div className="bg-primary rounded-full p-1 flex-shrink-0 mt-1" data-id="element-180">
                  <CheckIcon size={16} className="text-white" data-id="element-181" />
                </div>
                <p className="text-left" data-id="element-182">💥 Romper el hábito emocional.</p>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="flex items-start gap-3" data-id="element-183">
                <div className="bg-primary rounded-full p-1 flex-shrink-0 mt-1" data-id="element-184">
                  <CheckIcon size={16} className="text-white" data-id="element-185" />
                </div>
                <p className="text-left" data-id="element-186">💥 Cambiar patrones de vida.</p>
              </motion.div>
            </div>
            <p className="text-lg font-medium mt-8" data-id="element-187">
              No es magia. Es ciencia + método + decisión.
            </p>
          </div>
          <div className="mt-12" data-id="element-188">
            <h3 className="text-2xl font-medium text-primary-dark mb-4" data-id="element-189">
              ¿Lista para sentirte de nuevo tú?
            </h3>
            <p className="mb-8" data-id="element-190">
              Tu salud lo pide. Tu cuerpo lo merece. Tú ya lo has decidido.
            </p>
            <p className="text-lg mb-6" data-id="element-191">Haz clic ahora y empieza hoy:</p>
            <CTAButton className="text-xl py-4 px-10" data-id="element-192">
              QUIERO MI RETO DE 21 DÍAS — 29 €
            </CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
};
export default PricingSection;